<template>
  <div id="file-manipulation-controller-view">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'FileManipulationControllerView',
};
</script>

<style lang="scss" scoped>
  #file-manipulation-controller-view {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

</style>
